import React, {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import {deepLinkToLinkInfo, getCardTitle, getDeeplinkImage, isMac} from "../../Utility";
import {
    decodeDeeplink,
    firstLetterUpper,
    formatDate,
    getImagePath, getImagePathWithSvg, getImagePathWithTheme,
    isInDraw, isNumber, isString
} from "../../utils";
import {postMessage, recvMessage, unSubscribe} from "../../common/event";
import {
    EVENT_OPEN_LIBRARY_ITEM, EVENT_REFRESH_DEEPLINK, EVENT_REFRESH_DEEPLINK_TITLE,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    FROM_LIBRARY,
    KEY_IS_FIRST_OPEN_LIBRARY_REF, MAX_Z_INDEX, usedColorToShowColor
} from "../../Const";
import i18next, { t } from "i18next";
import {Dropdown, message,Tooltip } from "antd";
import {dbGetHighlight, getCardById, getNoteById} from "../../../model";
import {findNodeWithParents, loopAllNode} from "../../TreeUtils";

const mTitleCache:any = {};
const mImageCache:any = {};
const CustomDeeplink = forwardRef((props:{url:any,onItemClick?:any,from?:any},ref)=>{
    const [isOpen,setIsOpen] = useState(false);
    const [isExist,setIsExist] = useState(true);
    const [title,setTitle] = useState(mTitleCache[props.url] || '');
    const [libraryData,setLibraryData] = useState<any>(null);
    const [data,setData] = useState<any>(null);
    const [parentLibraryData,setParentLibraryData] = useState<any>(null);
    const [videoNote,setVideoNote] = useState(null);
    const bCanShowTooltip = useRef(false);
    const mDeeplink = useRef<any>(null);

    const mIsShowContextMenu = useRef(false);
    //是否是独占的link
    const [isExclusiveDeeplink,setIsExclusiveDeeplink] = useState(false);

    const spContainerRef = useRef(null);

    useEffect(()=>{
        const deeplink = decodeDeeplink(props.url);
        mDeeplink.current = deeplink;

        setTitle(mTitleCache[props.url]);

        // recvMessage(EVENT_REFRESH_DEEPLINK_TITLE,(msg,data)=>{
        //     const libraryData = data.data.data;
        //     if (libraryData?.id == deeplink?.id){
        //         setTitle(libraryData.name);
        //     }
        // })

        refreshDeeplink(deeplink);

        return ()=>{
            // unSubscribe(EVENT_REFRESH_DEEPLINK_TITLE);
        }

    },[props.url])

    useEffect(() => {
        if (props.url){
            mTitleCache[props.url] = title;
        }
    }, [title]);

    useEffect(() => {
        /**
         * 刷新deeplink
         */
        // recvMessage(EVENT_REFRESH_DEEPLINK,(msg,data)=>{
        //     if (data.data.id == mDeeplink.current?.id){
        //         refreshDeeplink(mDeeplink.current);
        //     }
        // })
        //
        // return ()=>{
        //     unSubscribe(EVENT_REFRESH_DEEPLINK);
        // }
    });

    /**
     * 刷新
     */
    const refreshDeeplink = (deeplink:any)=>{
        // const deeplink = decodeDeeplink(node.attrs.href);
        if (deeplink.type == 'project'){
            bCanShowTooltip.current = false;
            //region project
            getNoteById(deeplink.id).then((res)=>{
                res.type = 'project';
                setData(res);
                if (res && res?.isDeleted != 1){
                    setIsExist(true);

                    let szContent = res.name;
                    const jsonDoc = JSON.parse(res.doc);
                    let szBoardName = '';
                    let mElement: any;

                    let bFinished = false;
                    loopAllNode(jsonDoc.canvas,(board)=>{
                        if (!bFinished && board.key == deeplink.childId) {
                            const parents = findNodeWithParents(jsonDoc.canvas,board.key);
                            if (parents.parents){
                                for (let i=0;i<parents.parents.length;i++){
                                    szBoardName += parents.parents[i].title + ' / ';
                                }
                            }
                            szBoardName += board.title;

                            for (let j = 0; j < board.drawJson.elements.length; j++) {
                                const element = board.drawJson.elements[j];
                                if (element.id == deeplink.elementId) {
                                    mElement = element;
                                    bFinished = true;
                                }
                            }
                        }
                    })

                    if (deeplink.elementId) {
                        //取元素名称
                        if (deeplink.elementType == 'text') {
                            //取这个文本的内容
                            szContent += '->' + mElement?.text
                        }else if (deeplink.elementType == 'card'){
                            szContent += '->' + mElement?.customData?.generationData?.name || t("Untitled");
                        }
                        else {
                            szContent += '->' + firstLetterUpper(deeplink.elementType);
                        }

                    } else if (deeplink.childId) {
                        //子board
                        szContent += '->' + szBoardName;
                    }
                    setTitle(szContent);

                }else{
                    setIsExist(false);
                }
            })
            //endregion
        }else if (deeplink.type == 'library'){
            if (deeplink.childType == 'pdfAnno' || deeplink.childType == 'cardAnno'){
                getCardById(deeplink.id)?.then(async (res)=> {
                    if (res){
                        setData(res);
                        const pdfLib: any = await getCardById(res.id);
                        setIsExist(pdfLib && pdfLib.isDeleted != 1)
                        setLibraryData(pdfLib);

                        let szContent = pdfLib.name + '->' + (res.comment || res.text);
                        if (pdfLib.annoType == 'image'){
                            szContent = pdfLib.name + '->' + (res.comment || t("Area highlight"));
                        }
                        setTitle(szContent);
                    }
                });
            }else{
                getCardById(deeplink.id,false).then((res)=>{
                    if (res && res?.isDeleted != 1){
                        setData(res);
                        setIsExist(true);
                        if (bCanShowTooltip.current){
                            if (res.type == 'pdf' || res.type == 'video' || res.type == 'card' || res.type == 'journal'){

                            }else{
                                bCanShowTooltip.current = false;
                            }
                        }
                    }else{
                        setIsExist(false);
                    }
                    setTitle(getCardTitle(res))
                })
            }

        }else if (deeplink.type == 'highlight'){
            dbGetHighlight(deeplink.id).then(res=>{

                if (res){
                    setLibraryData(res);
                    const videoNote = res.data.find(p=>p.id == deeplink.childId);
                    setIsExist(videoNote != undefined && videoNote != null);
                    setVideoNote(videoNote);
                    let szTime = formatDate(videoNote.time,'hh:mm:ss');
                    if (szTime.startsWith('00:')){
                        szTime = formatDate(videoNote.time,'mm:ss');
                    }
                    getCardById(deeplink.id)?.then(library=>{
                        setData(library);
                        if (library){
                            setParentLibraryData(library);
                            const szContent = (library.name || res.name) + `(${szTime})` + '->'+(videoNote.title||videoNote.content);
                            setTitle(szContent);

                            res.name = library.name || res.name;
                            setLibraryData(res);
                        }
                    })
                }
            })
        }
    }


    const handMenuClick = (event) => {
        event.domEvent.stopPropagation();
    }

    const getTitle = (title:any)=>{
        if (isString(title)){
            const arraySplits = title?.split('\n');
            if (arraySplits.length > 0){
                return arraySplits[0];
            }
            return '';
        }
        if (isNumber(title)){
            return title+'';
        }
        return '';
    }

    const getImgSrc = (szImgName:any)=>{
        let szImageName = '';
        if (!isExist){
            szImageName = getImagePathWithTheme(szImgName);
        }else{
            szImageName = getImagePathWithSvg(szImgName + '_blue');
        }
        if (data?.type){
            mImageCache[props.url] = szImageName;
        }

        return szImageName;
    }


    return <Tooltip open={isOpen} onOpenChange={(visible) => {
        if (bCanShowTooltip.current) {
            setIsOpen(visible);
        } else {
            setIsOpen(false);
        }
    }} placement={'bottomLeft'}
                   title={i18next.t("CtrlClickToOpenInSlider").replace("Ctrl", isMac() ? 'Cmd' : 'Ctrl')}
                   arrow={false}>
                    <span className={'cursor-pointer'} ref={spContainerRef} style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // alignItems: 'center',
                        marginTop: '0px',
                        marginBottom: (isExclusiveDeeplink)?'10px':'0px',
                        opacity: isExist ? '1' : '0.25',
                        fontSize: '12px',
                        width:'100%'
                    }} onClick={(event)=>{
                        // event.stopPropagation();
                        //阻止click的事件传递。。。。库页面打开card--链接打开别的弹窗。。。。
                        if (props.onItemClick){
                            props.onItemClick();
                        }
                    }} onMouseDown={async (event: any) => {

                        if (event.metaKey || event.ctrlKey) {
                            event.stopPropagation();
                            // event.preventDefault();
                        }

                        /*
                        if (!isExist) {
                            message.info(i18next.t('LinkBeDeleted'));
                            return;//已删除。
                        }
                        const deeplink = decodeDeeplink(node.attrs.href);
                        if (isInDraw()) {
                            if (deeplink.childType == 'pdf') {
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        }
                        if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                            postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                id: deeplink.id,
                                from: FROM_LIBRARY,
                                deeplink: deeplink,
                                selectedId: deeplink.childId,
                                inSlider: (event.metaKey || event.ctrlKey)
                            })
                            if (deeplink.childType == 'card' || deeplink.childType == 'video' || deeplink.childType == 'pdf' || deeplink.childType == 'highlight') {
                                if (window.location.href.includes('/card') || window.location.href.includes('/journal')) {
                                    const hasFirst = localStorage.getItem(KEY_IS_FIRST_OPEN_LIBRARY_REF) || 'true';
                                    if (hasFirst == 'true') {
                                        message.info(t("HoldCtrlDownAndCtrl").replace('Cmd',(isMac()?'Cmd':'Ctrl')));
                                        localStorage.setItem(KEY_IS_FIRST_OPEN_LIBRARY_REF,'false')
                                    }
                                }
                            }
                        } else {
                            const linkInfo = await deepLinkToLinkInfo(deeplink);
                            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo,inSlider:(event.metaKey || event.ctrlKey)});
                        }

                         */
                    }}>
                        <>
                                    <img data-type={'no-apply-hidden'} style={{
                                        opacity: '1',
                                        transform: 'none',
                                        position: 'relative',
                                        visibility: 'visible',
                                        width: '16px',
                                        height: '16px',
                                        marginLeft: '2px',
                                        marginTop: '0px'
                                    }}
                                         src={mImageCache[props.url] || getImgSrc(getDeeplinkImage(data?.type)?.replace(".png", ""))}/>

                                    <div className={`div-span-container ${isExclusiveDeeplink ? 'ml-12' : 'ml-6'}`}
                                         style={{marginTop: '0px', marginRight: '2px'}}>
                                        <span className={isExclusiveDeeplink ? 'text-truncate' : 'text-truncate-1'}
                                              style={{
                                                  fontSize: '12px',
                                                  color: '#5281D8'
                                              }}>{getTitle(title)}</span>
                                        </div>
                                </>
                    </span>
    </Tooltip>
})

export default React.memo(CustomDeeplink,(prevProps,nextProps)=>{
    return (prevProps.url == nextProps.url);
});